export const PATHS = {
	SEARCH: "/search",
	TERMS: "https://www.storage.com/about-us/terms-and-conditions/",
	PRIVACY: "https://www.storage.com/about-us/privacy/",
};
